import { Grid } from '@mui/material';
import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LoggingContext } from '../Context/LoggingContext/LoggingContext';
import { NoMeasurementsOverlay } from './NoMeasurementsOverlay';
import PercentageFitCircle from './PercentageFitCircle';
import WeightMeasuresDialog from './WeightMeasuresDialog/WeightMeasuresDialog';

interface PercentageFitAndReliabilityProps {
  fitPercentage: number;
  reliabilityPercentage: number;
  size?: number;
  thickness?: number;
  id: string;
}

export default function PercentageFitAndReliability({
  fitPercentage,
  reliabilityPercentage,
  size = 80,
  thickness = 4,
  id,
}: PercentageFitAndReliabilityProps) {
  const location = useLocation();
  const { addLog } = useContext(LoggingContext);
  const [weightMeasureSettingsDialogOpenState, setWeightMeasureSettingsDialogOpenState] =
    useState(false);

  return (
    <NoMeasurementsOverlay>
      <WeightMeasuresDialog
        weightMeasureSettingsDialogOpenState={weightMeasureSettingsDialogOpenState}
        setWeightMeasureSettingsDialogOpenState={setWeightMeasureSettingsDialogOpenState}
      />
      <Grid
        container
        justifyContent='space-around'
        direction='row'
        id={id}
        style={{ cursor: 'pointer', position: 'relative' }}
        onClick={() => {
          addLog('Clicked fit/reliability circles to open weighting dialog', location.pathname);
          setWeightMeasureSettingsDialogOpenState(true);
        }}
      >
        <PercentageFitCircle value={fitPercentage} title='fit' size={size} thickness={thickness} />
        <PercentageFitCircle
          value={reliabilityPercentage}
          title='reliability'
          size={size}
          thickness={thickness}
        />
      </Grid>
    </NoMeasurementsOverlay>
  );
}

PercentageFitAndReliability.defaultProps = {
  size: 80,
  thickness: 4,
};
